export default __webpack_public_path__ + "static/media/16.33353a36.jpg";